import { createAsyncThunk } from "@reduxjs/toolkit";

import { createSofEntry as createSofEntryApi, deleteSofEntry as deleteSofEntryApi, fetchSofEntries, updateSofEntry as updateSofEntryApi } from "../../apis/sof";

export const getSof = createAsyncThunk(
  "sof/getSof",
  async (
    { csofIds }: { csofIds: string[] },
    { rejectWithValue }
  ) => {
    try {
      const entriesArrays = await Promise.all(
        csofIds.map((csofId) => fetchSofEntries(csofId))
      );
      const allEntries = entriesArrays.flat();
      return {
        data: allEntries,
        total: allEntries.length,
      };
    } catch (error: any) {
      console.log("error->", error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateSofEntry = createAsyncThunk(
  "sof/updateSofEntry",
  async (
    {
      id,
      data,
    }: { id: string; data: Record<string, any>; previousEntry: any },
    { rejectWithValue }
  ) => {
    try {
      const result = await updateSofEntryApi(id, data);
      return { id, data: result };
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createSofEntry = createAsyncThunk(
  "sof/createSofEntry",
  async (
    data: { csof_id: string; job_id: string; [key: string]: any },
    { rejectWithValue }
  ) => {
    try {
      const result = await createSofEntryApi(data);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteSofEntry = createAsyncThunk(
  "sof/deleteSofEntry",
  async (
    { id, entry }: { id: string; entry: any },
    { rejectWithValue }
  ) => {
    try {
      await deleteSofEntryApi(id);
      return { id };
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);